<template>
  <div class="w100 Contenido">
    <Titulo
      :seccion="datos.title"
      :icon="datos.icon"
      :productor="GetProductor"
      :establecimiento="GetEstablecimiento"
    />
    <Descripcion>
      {{ datos.description }}
    </Descripcion>

    <div
      class="DivInfoData"
      :class="{ Visible: !DataActualizada }"
      ref="DivInfoData"
    >
      <div class="fLeft">
        Info recuperada de fecha: <span ref="FechaData"></span>
      </div>

      <div
        class="fRight"
        v-on:click.stop="RefrescarInfo(info.idHerramientaEstablecimiento)"
      >
        <font-awesome-icon
          icon="sync-alt"
          size="4x"
          :style="{ color: 'white' }"
          class="IconoActualizar fLeft"
        />
        <!-- Actualizar -->
        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>

    <PdfTable
      :records="GetRecords()"
      :id-herramienta-establecimiento="idHerramientaEstablecimiento"
      @Refresh="RefrescarInfo()"
    />
  </div>
</template>

<script>
import ManejoDatos from "../../../Auxiliares/ManejoDatos";
import Clases from "../../../Auxiliares/Clases";

export default {
  name: "RegistrosManagerPdfTool",
  props:{
    datos:{
      type: Object,
      required: true
    },
    childRouteName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      info: null,
      DataActualizada: true,
      idHerramientaEstablecimiento: 0
    };
  },
  async mounted() {
    this.idHerramientaEstablecimiento = Number(this.$route.params.Id);
    this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
    if (this._UserOk) {
      await this.RefrescarInfo(this.idHerramientaEstablecimiento);
    }
  },
  methods: {
    GetRecords() {
      if (this.info != null) return this.info.records;
      return [];
    },
    async RefrescarInfo(idHerramientaEstablecimiento = this.idHerramientaEstablecimiento) {
      if (this.VistaActual(idHerramientaEstablecimiento)) {
        this.IntentoObtenerDataDeCache(idHerramientaEstablecimiento);
      }
      let result = await ManejoDatos.GetRegistrosHerramienta(
        idHerramientaEstablecimiento,
        this
      );
      this.GuardarDataEnCache(result);
      this.RefreshMe(result, idHerramientaEstablecimiento);
    },
    VistaActual(idHerramientaEstablecimiento) {
      if (this.$route.params.Id != idHerramientaEstablecimiento) return false;
      if (this.$route.name != this.childRouteName) return false;
      return true;
    },
    RefreshMe(info, idHerramientaEstablecimiento) {
      if (this.VistaActual(idHerramientaEstablecimiento)) {
        this.DataActualizada = false;
        if (info) {
          this.info = info;
          this.DataActualizada = true;
        }
      }
    },
    IntentoObtenerDataDeCache(idHerramientaEstablecimiento) {
      try {
        var data = Clases.RecuperarJsonDeStorage(
          this.KeyDataCacheada(idHerramientaEstablecimiento)
        );
        if (data != null) {
          this.info = data._Json;
          this.$refs.FechaData.innerHTML = data._Fecha._FechaYHora;
        }
      } catch (e) {
        console.log(e);
      }
    },
    GuardarDataEnCache(dataToSave) {
      var _Data = {
        _Fecha: new Clases.Fecha(new Date()),
        _Key: this.KeyDataCacheada(dataToSave.idHerramientaEstablecimiento),
        _Json: dataToSave,
      };
      Clases.GuardarJsonEnStorage(
        this.KeyDataCacheada(dataToSave.idHerramientaEstablecimiento),
        _Data
      );
    },
    KeyDataCacheada(idHerramientaEstablecimiento) {
      return (
        "InfoRegistrosHerramientaEstablecimientoId" +
        idHerramientaEstablecimiento
      );
    },
  },
  computed: {
    GetProductor() {
      if (this.info) return this.info.Productor;
      return "";
    },
    GetEstablecimiento() {
      if (this.info) return this.info.Establecimiento;
      return "";
    },
    GetInfo() {
      if (this.info != null) return this.info;
      return {};
    },
    GetIdHerramientaEstablecimiento() {
        return Number(this.idHerramientaEstablecimiento);
    },
  }
};
</script>